module.exports = __webpack_public_path__ + "static/Isotope-7cea157470c7cae07a43324d228e7dba.svg";